import { ForecastType } from '../schemas/index.js';
export class SummarizedForecastData {
    budget = 0;
    previousForecast = 0;
    forecast = 0;
    result = 0;
    remaining = 0;
    budgetLeft = 0;
    earnings = 0;
    constructor(forecastDataList, includeATA = true) {
        this.aggregate(forecastDataList, includeATA);
    }
    aggregate(forecastDataList, includeATA) {
        let totalBudget = 0;
        let totalPreviousForecast = 0;
        let totalForecast = 0;
        let totalResult = 0;
        let totalRemaining = 0;
        let totalBudgetLeft = 0;
        let totalEarnings = 0;
        forecastDataList.forEach((forecastData) => {
            forecastData.rows.forEach((subForecastData) => {
                if (!includeATA &&
                    (subForecastData.type === ForecastType.AtaOngoing ||
                        subForecastData.type === ForecastType.AtaFixed)) {
                    return;
                }
                totalBudget += subForecastData.budget ?? 0;
                totalPreviousForecast += subForecastData.previousForecast ?? 0;
                totalForecast += subForecastData.forecast ?? 0;
                totalResult += subForecastData.result ?? 0;
                totalRemaining += subForecastData.remaining ?? 0;
                totalBudgetLeft += subForecastData.budgetLeft ?? 0;
                totalEarnings += subForecastData.earnings ?? 0;
            });
        });
        this.budget = totalBudget;
        this.previousForecast = totalPreviousForecast;
        this.forecast = totalForecast;
        this.result = totalResult;
        this.remaining = totalRemaining;
        this.budgetLeft = totalBudgetLeft;
        this.earnings = totalEarnings;
    }
}
